import { IKeyStringValue } from 'common/types';
import { IScheduleDetail } from 'list/international/types';
import React, { ReactNode, createContext, useContext, useState } from 'react';
import { PriceTransparencyDetail } from 'types/apollo';

interface PriceTransparencyContextType {
  airports: IKeyStringValue;
  setAirports: React.Dispatch<React.SetStateAction<IKeyStringValue>>;
  originalTotalFare: number;
  setOriginalTotalFare: React.Dispatch<React.SetStateAction<number>>;
  priceTransparency: PriceTransparencyDetail[];
  setPriceTransparency: React.Dispatch<
    React.SetStateAction<PriceTransparencyDetail[]>
  >;
  selectedScheduleDetails: IScheduleDetail[];
  setSelectedScheduleDetails: React.Dispatch<
    React.SetStateAction<IScheduleDetail[]>
  >;
}

const PriceTransparencyContext =
  createContext<PriceTransparencyContextType | null>(null);

export const PriceTransparencyProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [airports, setAirports] = useState<IKeyStringValue>({});
  const [originalTotalFare, setOriginalTotalFare] = useState<number>(0);
  const [priceTransparency, setPriceTransparency] = useState<
    PriceTransparencyDetail[]
  >([]);
  const [selectedScheduleDetails, setSelectedScheduleDetails] = useState<
    IScheduleDetail[]
  >([]);

  const value = {
    airports,
    setAirports,
    originalTotalFare,
    setOriginalTotalFare,
    priceTransparency,
    setPriceTransparency,
    selectedScheduleDetails,
    setSelectedScheduleDetails,
  };

  return (
    <PriceTransparencyContext.Provider value={value}>
      {children}
    </PriceTransparencyContext.Provider>
  );
};

export const usePriceTransparency = () => {
  const context = useContext(PriceTransparencyContext);
  if (!context) {
    throw new Error(
      'usePriceTransparency must be used within a PriceTransparencyProvider',
    );
  }
  return context;
};
